import ButtonStyle from "@material-ui/core/Button";
import IconButtonStyle from "@material-ui/core/IconButton";
import styled, { createGlobalStyle } from "styled-components";
export const GlobalStyle = createGlobalStyle`
  html, body {
    margin: 0;
    padding: 0;
    width: 100%;
    height: 100%;
    overflow: hidden;
  }

  #digitalk-chat {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    font-family: 'Quicksand', sans-serif;
    font-size: 14px;
    display: flex;
    margin: 0;
    padding: 0;
    height: 100%;
    width: 100%;
  }
    
  #digitalk-chat .hidden {
     display: none;
  }
`;

export const Button = styled(ButtonStyle)`
  && {
    position: fixed;
    right: 32px;
    bottom: 32px;
    background-color: ${({ theme }) => theme.palette.primary.main};
    color: #ffffff;
    width: 64px;
    height: 64px;

    border-radius: 50%;

    &:hover {
      background-color: ${({ theme }) => theme.palette.primary.hover};
    }

    span {
      font-size: 18px;
      text-wrap: none;
      text-transform: none;

      svg {
        width: 32px;
        height: 32px;
      }
    }
  }
`;

export const IconButton = styled(IconButtonStyle)`
  && {
    cursor: pointer;
    svg {
      height: 13px;
    }

    &.digitalk-close {
      color: #fff;
    }

    &.digitalk-arrowDown {
      color: #fff;
    }
  }
`;

export const Header = styled.div`
  display: flex;
  height: 45px;
  justify-content: space-between;
  padding: 0 0px 0 16px;
  align-items: center;
  background: ${({ theme }) => theme.palette.primary.main};

  > div {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-weight: bold;
    font-size: 18px;
  }
  img {
    height: 30px;
  }

  .digitalk-title {
    font-size: 14px;
    font-weight: 700;
    color: #ffffff;
  }
`;

export const Container = styled.div`
  width: 100vw;
  height: 100vh;
  border-radius: 0;
  overflow: hidden;
  background: #ffffff;
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  flex-direction: column;
  z-index: 999;

  @media (max-width: 500px) {
    height: 100vh;
    width: 100vw;
    border-radius: 0;
    right: 0;
    bottom: 0;
  }
`;
